<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click="handleSaveSubmit">{{$t('保存更改')}}</el-button>
      <el-button @click="handleChangeExpandState">{{expandState ? $t('收起') : $t('展开')}}</el-button>
<!--      <el-button @click.native="handleBatchDelete">导出</el-button>-->
    </template>

    <template #search-form>
      <el-form-item :label="$t('地区名称')">
        <el-input :placeholder="$t('地区名称')" v-model="searchForm.useArea" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="resetEmpty()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <vxe-table
          :height="height - 32"
          ref="treeTable"
          border
          :column-config="{resizable: true}"
          show-overflow
          :scroll-y="{enabled: true, gt: 0}"
          :data="tableData"
          :checkbox-config="{highlight: true}"
          :tree-config="{rowField: 'code', childrenField: 'subBeans'}"
      >
        <vxe-column type="checkbox" width="60" fixed="left"></vxe-column>

        <vxe-column :title="$t('校正地区')" field="area" tree-node></vxe-column>
        <vxe-column :title="$t('使用地区')" field="useArea"></vxe-column>
        <vxe-column :title="$t('补偿值')">
          <template v-slot="{row}">
            <el-input v-model="row.compensate" :placeholder="$t('请输入补偿值')" v-if="row.useArea" />
          </template>
        </vxe-column>

        <vxe-column :title="$t('补偿值协议代码')" field="name">
          <template v-slot="{row}">
            {{formatProtocolCode(row)}}
          </template>
        </vxe-column>
      </vxe-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import getProtocolCode from "@/utils/crcUtils";
import AnkhList from "@/components/list/AnkhList.vue";
import {resetEmpty} from "@/utils/common";

export default {
  name: "AreaList",
  components: {AnkhList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      expandState: true,
    }
  },
  methods: {
    resetEmpty,
    // 格式化协议代码
    formatProtocolCode(row) {
      if(!row.compensate) return;
      const compensate = row.compensate.trim();
      const target = parseInt(compensate);
      if(!compensate || isNaN(target)) return;
      const str = "ee140100" + (compensate.length % 2 !== 0 ? "0" + target.toString(16) : target.toString(16));
      const result = getProtocolCode(str);
      row.protocolCode = result;
      return result;
    },

    // 保存提交
    async handleSaveSubmit() {
      try {
        const params = this.buildSubmitParams();
        await request(this.$api.lonLatCorrectRecord.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      } catch (e) {
        console.log(e);
      }
    },

    // 构建提交参数
    buildSubmitParams() {
      const params = [];
      const fn = (list) => {
        list.forEach(item => {
          const children = item.subBeans || [];
          delete item.subBeans;
          if (children && children.length) {
            fn(children);
          }
          params.push(item);
        })
      }
      fn(JSON.parse(JSON.stringify(this.tableData)));
      return params;
    },



    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.lonLatCorrectRecord.list, params);
        this.tableData = res.lonLatCorrectRecords;
        this.$nextTick(() => {
          this.handleExpandTree();
        })
      } catch (e) {
        console.error(e);
      }
    },

    // 展开树
    handleExpandTree() {
      const $table = this.$refs.treeTable
      if ($table) {
        $table.setAllTreeExpand(true)
      }
    },

    // 展开/收起
    handleChangeExpandState() {
      this.expandState = !this.expandState;
      const $table = this.$refs.treeTable
      if ($table) {
        $table.setAllTreeExpand(this.expandState);
      }
    }
  },
  mounted() {
    this.handleSearch();
  }
}
</script>

<style scoped>

</style>
